import { PaymentsChart } from "@components/charts/PaymentsChart";
import { navigateTo } from "context/navigation.service";
import type { Payment } from "types/payment";

export default function PaymentsChartWidget({ payments }: { payments: Payment[] }) {
  return (
    <div className="flex flex-col bg-white border rounded-xl p-4 gap-2 shadow-lg">
      <PaymentsChart payments={payments} defaultPeriod="7d" onViewAll={() => navigateTo({ route: "/settings?page=paiements" })} />
    </div>
  );
}
